import React from 'react';
import {
  Edit,
  Create,
  SimpleForm,
  NumberInput,
  BooleanInput,
} from 'react-admin';

const DepositSettingsFields = () => (
  <>
    <NumberInput source="min_deposit_1st" label="Min deposit 1st" defaultValue={100} />
    <NumberInput source="min_deposit_2nd" label="Min deposit 2nd" defaultValue={200} />
    <NumberInput source="min_deposit_3rd_plus" label="Min deposit 3rd plus" defaultValue={500} />

    <BooleanInput source="new_user_bonus_enabled" label="New user bonus enabled" defaultValue={true} />
    <NumberInput source="new_user_bonus_percent" label="New user bonus percent" defaultValue={10} />

    <BooleanInput source="existing_user_bonus_enabled" label="Existing user bonus enabled" defaultValue={true} />
    <NumberInput source="existing_user_bonus_percent" label="Existing user bonus percent" defaultValue={5} />

    <BooleanInput source="referral_first_deposit_enabled" label="Referral first deposit enabled" defaultValue={true} />
    <NumberInput source="referral_first_deposit_percent" label="Referral first deposit percent" defaultValue={20} />

    <BooleanInput source="referral_repeat_deposit_enabled" label="Referral repeat deposit enabled" defaultValue={false} />
    <NumberInput source="referral_repeat_deposit_percent" label="Referral repeat deposit percent" defaultValue={5} />
  </>
);

export const DepositSettingsEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <DepositSettingsFields />
    </SimpleForm>
  </Edit>
);

export const DepositSettingsCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <DepositSettingsFields />
    </SimpleForm>
  </Create>
);